import React from "react";

/**
 * Hook to define states related to configurations, templates, and pagination.
 */
export const useBackendStates = ({ name = "Backend states", logOther = false }) => {
    const [programStatus, setProgramStatus] = React.useState(null);

    const [examinationStatistics, setExaminationStatistics] = React.useState(null);
    const [patientStatistics, setPatientStatistics] = React.useState(null);

    React.useEffect(() => {
        if (!logOther) return;

        console.log(`=== ${name} other ===`);
        console.log("programStatus", JSON.parse(JSON.stringify(programStatus)));
        console.log("examinationStatistics", JSON.parse(JSON.stringify(examinationStatistics)));
        console.log("patientStatistics", JSON.parse(JSON.stringify(patientStatistics)));
        console.log("\n");
    }, [programStatus, examinationStatistics, patientStatistics]);

    return {
        // Other.
        programStatus,
        setProgramStatus,

        examinationStatistics,
        setExaminationStatistics,
        patientStatistics,
        setPatientStatistics
    };
};
